import SlideDownUp from "./SlideDownUp";

export default SlideDownUp;
